import PlaceholderContent from '../../components/PlaceholderContent';
import ChatLayout from '../../Layout/ChatLayout';

const ChatScreen = () => {
    return (
        <ChatLayout className="CHATS">
            <div className="Chat__Home">
                <div className="chat-content">
                    <PlaceholderContent />
                </div>
            </div>
        </ChatLayout>
    );
};

export default ChatScreen;
